
 /* eslint-disable */ 

import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '../store/useAuth'
import { useCart } from '../store/useCart'
import { applyRouteSeo } from '@/utils/pageSeo'
import { setDefaultPageTitle } from '@/utils/seoUtils'
import { ALL_CATEGORIES_SLUG } from '@/constants'


const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/catalog/',
    name: 'catalog',
    redirect: {
      name: 'category',
      params: { categorySlug: ALL_CATEGORIES_SLUG }
    }
  },
  {
    path: '/category/:categorySlug',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ '../views/CategoryView.vue')
  },
  {
    path: '/user/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "user" */ '../views/ProfileView.vue')
  },
  {
    path: '/user/orders',
    name: 'orders',
    component: () => import(/* webpackChunkName: "user" */ '../views/UserView.vue')
  },
  {
    path: '/user/orders/:orderNumber',
    name: 'order-detail',
    component: () => import(/* webpackChunkName: "user" */ '../views/OrderDetailView.vue')
  },
  {
    path: '/user/',
    name: 'user',
    redirect: '/user/profile'
  },
  {
    path: '/category/:categorySlug/product/:productSlug',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '../views/ProductView.vue')
  },
  {
    path: '/search/:searchQuery',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/SearchView.vue')
  },
  {
    path: '/login/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
  },
  {
    path: '/registration/',
    name: 'registration',
    component: () => import(/* webpackChunkName: "registration" */ '../views/RegistrationView.vue'),

  },
  {
    path: '/cart/',
    name: 'cart',
    component: () => import(/* webpackChunkName: "cart" */ '../views/CartView.vue')
  },
  {
    path: '/checkout/',
    name: 'checkout',
    component: () => import(/* webpackChunkName: "checkout" */ '../views/CheckoutView.vue')
  },
  {
    path: '/password-reset/',
    name: 'password-reset',
    component: () => import(/* webpackChunkName: "password-reset" */ '../views/PasswordResetView.vue')
  },
  {
    path: '/user/addresses',
    name: 'addresses',
    component: () => import(/* webpackChunkName: "user" */ '../views/AdressesView.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import(/* webpackChunkName: "policy" */ '../views/PolicyView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/stroitelstvo',
    name: 'construction',
    component: () => import(/* webpackChunkName: "construction" */ '../views/ConstructionView.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import(/* webpackChunkName: "contacts" */ '../views/ContactsView.vue')
  },
  {
    path: '/delivery',
    name: 'delivery',
    component: () => import(/* webpackChunkName: "delivery" */ '../views/DeliveryView.vue')
  },
  {
    path: '/offer',
    name: 'offer',
    component: () => import(/* webpackChunkName: "legal" */ '../views/OfferView.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "legal" */ '../views/TermsView.vue')
  },
  {
    path: '/returns',
    name: 'returns',
    component: () => import(/* webpackChunkName: "legal" */ '../views/ReturnsView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFoundView.vue')
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    // При переключении подкатегорий оставляем текущую позицию прокрутки
    if (to.name === 'category' && from.name === 'category') {
      return false
    }

    return { top: 0, behavior: 'auto' }
  }
})

router.beforeEach(async (to, from) => {

  const isLogin = localStorage.getItem('isLogin') === '1';

  if (isLogin && (to.name === 'login' || to.name === 'registration')) {
    return { name: 'home' }
  }

  if (!isLogin && (to.name === 'user' || to.name === 'profile' || to.name === 'addresses' || to.name === 'orders' || to.name === 'order-detail')) {
    return { name: 'home' }
  }

  if(!isLogin && (to.name === 'checkout') && (from.name !== 'registration' && from.name !== 'login')) {
    useAuth().startCheckout = true;
    return { name: 'login' }
  }

  if(useCart().cartCount === 0 && useAuth().startCheckout !== true && (to.name === 'checkout') && (from.name !== 'registration' && from.name !== 'login')) {
    return { name: 'home' }
  }

  if(useAuth().startCheckout === true && (to.name === 'checkout') && !isLogin) {
    useAuth().startCheckout = false;
  }

  if(useAuth().startCheckout === true && (to.name !== 'registration' && to.name !== 'login') && (from.name === 'registration' || from.name === 'login')) {
    useAuth().startCheckout = false;
  }
})

router.afterEach((to) => {
  applyRouteSeo(to)
})

setDefaultPageTitle()

export default router
